import { initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
// Initialize Faro for frontend observability
export function initFaro() {
    // Determine base domain: sitzkrieger.com or sitzkrieger.elyria.cben.dev
    const hostname = window.location.hostname;
    const isDev = hostname.includes('elyria.cben.dev');
    const baseDomain = isDev ? 'sitzkrieger.elyria.cben.dev' : 'sitzkrieger.com';
    const faroUrl = `https://faro.${baseDomain}`;
    initializeFaro({
        url: `${faroUrl}/collect`,
        app: {
            name: 'Sitzkrieger',
            version: '1.0.0',
            environment: isDev ? 'development' : 'production',
        },
        instrumentations: [
            new TracingInstrumentation(),
        ],
        batching: {
            enabled: true,
            sendTimeout: 250,
        },
    });
    console.log(`Grafana Faro initialized for Sitzkrieger frontend, sending to ${faroUrl}/collect`);
}
